function App(props) {
  const { children } = props;

  return <>{children}</>;
}

export default App;
